module.exports = __webpack_public_path__ + "assets/img/richText.e63ed7ed.svg";